import { combineReducers } from 'redux';
import { reducer } from 'redux-form';

export const rootReducer = combineReducers({
  form: reducer,
});
